import { render } from "./SelectCanalVenta.vue?vue&type=template&id=f67094ea&scoped=true"
import script from "./SelectCanalVenta.vue?vue&type=script&lang=js"
export * from "./SelectCanalVenta.vue?vue&type=script&lang=js"

import "./SelectCanalVenta.vue?vue&type=style&index=0&id=f67094ea&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f67094ea"]])

export default __exports__